import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { storedValudationData } from 'src/app/models/urlAuthParams.model';
import { addValuationDocument } from 'src/app/models/valuation-request';
import { valuationByHash } from 'src/app/models/valuation.model';
import { ApiService } from 'src/app/services/api.service';
import { ValuationService } from 'src/app/services/valuation.service';
import { SHARED_IMPORTS } from '../../shared/standalone-imports';

@Component({
  selector: 'app-edit-infomation',
  templateUrl: './edit-information.component.html',
  styleUrls: ['./edit-information.component.scss'],
  standalone: true,
  imports: [...SHARED_IMPORTS],
})
export class EditInformationComponent implements OnInit {
  public validationForm: UntypedFormGroup;
  public valuationData: valuationByHash;
  public valuationDataAuth: any;
  public displayedFields = [];

  public submitted = false;
  public frontUploadOk = false;
  public backUploadOk = false;
  public documentUploading = false;
  public uploadDocumentError = '';
  public showThankYou = false;

  constructor(
    public fb: UntypedFormBuilder,
    private readonly api: ApiService,
    private readonly router: Router,
    private readonly ngxService: NgxUiLoaderService,
    private readonly route: ActivatedRoute,
    private readonly valuationService: ValuationService,
  ) {

    localStorage.setItem('state', '/informatie-bewerken');

    this.validationForm = fb.group({
      licenseCardFront: [null, [Validators.required]],
      licenseCardBack: [null, [Validators.required]],
    });
  }

  public get f() { return this.validationForm.controls; }

  public ngOnInit(): void {
    this.ngxService.start();
    // Get route params used in servcie
    this.route.params.subscribe((routeParams) => {
      // Sync data
      this.valuationService.syncValuationData(routeParams).then(data => {
        this.valuationData = data;
        // Check if verified has been set.
        if (localStorage.getItem('verified') == null) {
          this.router.navigate(['/verificatie']);
        } else {
          // Verified has been set, check time between now and checked.
          if (Number(new Date().getTime()) - Number(localStorage.getItem('verified')) < 900000) {
            // Less than 15 minutes, do something. We are save to do api actions.
            const valuationAuth: storedValudationData = JSON.parse(localStorage.getItem('valuation'));
            this.api.getValuationId(valuationAuth.id).subscribe(data => {
              this.valuationDataAuth = data.data;
              this.displayEditFields();
            })
          } else {
            // More than 15 minutes, re-verify.
            this.router.navigate(['/verificatie']);
          }
        }
      }, error => {
        console.error(error);
      })
    });
  }

  public displayEditFields() {
    // Check what document fields we need to show
    if (this.valuationDataAuth.Documents) {

      // All documents are satisfied. Show thank you message.
      if (this.valuationDataAuth.Documents.length == 2) {
        this.showThankYou = true;
      }

      if (this.valuationDataAuth.Documents.filter(document => document.type == "registrationcard_front").length == 0) {
        this.displayedFields.push({ type: 'registrationcard_front' })
      }

      if (this.valuationDataAuth.Documents.filter(document => document.type == "registrationcard_back").length == 0) {
        this.displayedFields.push({ type: 'registrationcard_back' })
      }
    } else {
      // Both documents are rejected.
      this.displayedFields.push({ type: 'registrationcard_front' })
      this.displayedFields.push({ type: 'registrationcard_back' })
    }
  }

  public uploadValuationDocument(type: string, file: FileList) {
    this.documentUploading = true;
    const fileToUpload: File = file[0];
    const reader = new FileReader();
    reader.readAsDataURL(fileToUpload);
    reader.onload = () => {
      const valuationAuth: storedValudationData = JSON.parse(localStorage.getItem('valuation'));
      let submitData: addValuationDocument = {
        documentContent: reader.result,
        type: type
      };

      this.api.addValuationDocument(valuationAuth.id, submitData).subscribe(data => {
        if (data.error == false) {
          this.documentUploading = false;
          if (type == 'registrationcard_front') {
            this.frontUploadOk = true;
          } else if (type == 'registrationcard_back') {
            this.backUploadOk = true;
          }
        } else {
          this.documentUploading = false;
          this.uploadDocumentError = data.message;
        }
      })
    }
  }

  public needToEdit(name: string) {
    if (this.displayedFields.filter(field => field.type == name).length > 0) {
      return true;
    } else {
      return false;
    }
  }

  public onSubmit() {
    this.submitted = true;
    // stop here if form is invalid
    if (this.validationForm.invalid) {
      this.showThankYou = true;
      return;
    }
  }
  
  public close() {
    window.location.href = "https://autoverkooppartner.nl/";
  }
}
